import ProjectService from '../../project.service';
import Service from '@/service/index.js';
import AssetsInfo from '@/components/assets-info/assets-info.vue';
import { mapGetters } from 'vuex';

export default {
  components: {
    AssetsInfo
  },
  data() {
    return {
      detail: {},
      signApproveStatus: [],
      purposeArr: [],
      landType: [],
      userEconomic: [],
      paymentMethod: [],
      signFiles: [],
      fileInfo: {},
      marginInfo: {},
      bidInfo: {detail: []}
    };
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  created () {
    Service.getSelectList('SIGN_PEOPLE_BID_FILE_TYPE').then(res => {
      if (res && res.code === '0') {
        const arr = res.data.sort((a, b) => a.sort - b.sort).splice(0, 3);
        this.initFile(arr);
      }
    });
    Service.getSelectList('MASSIF_TYPE').then(res => {
      if (res && res.code === '0') {
        this.landType = res.data;
      }
    });
    Service.getSelectList('TRANSFEREE_PURPOSE').then(res => {
      if (res && res.code === '0') {
        this.purposeArr = res.data;
      }
    });
    Service.getSelectList('SIGN_APPROVE_STATUS').then(res => {
      if (res && res.code === '0') {
        this.signApproveStatus = res.data;
      }
    });
    Service.getSelectList('PURCHASE_PAYMENT_METHOD').then(res => {
      if (res && res.code === '0') {
        this.paymentMethod = res.data;
      }
    });
    this.id = this.$route.query.id;
    if (this.id) {
      this.getSignUpPurchaseDetail();
    }
  },
  methods: {
    getIdentityList () {
      let type = 'ECONOMIC_MEMBER_TYPE';
      if (this.projectInfo && this.projectInfo.projectType === 1 && this.projectInfo.projectSubType === 2) {
        type = 'ECONOMIC_MEMBER_TYPE_1_2';
      }
      Service.getSelectList(type).then(res => {
        if (res && res.code === '0') {
          this.userEconomic = res.data;
        }
      });
    },
    initFile (arr) {
      arr.forEach(item => {
        this.signFiles.push({
          projectFileType: Number(item.code),
          title: item.value,
          filePaths: []
        });
      });
    },
    toOtherPage() {
      window.open(this.detail.acceptNotice);
    },
    getSignUpPurchaseDetail() {
      ProjectService.getSignUpProjectDetail(this.id).then(res => {
        if (res && res.code === '0') {
          this.getIdentityList();
          this.detail = res && res.data;
          if (this.detail.projectType === 8) {
            this.detail.purpose = this.detail.purpose && JSON.parse(this.detail.purpose);
          }
          this.bidInfo = {
            detail: [
              {
                assetsInfo: this.detail.assertInfo,
                bidCode: this.detail.limitStartTime,
                bidId: this.detail.bidId,
                bidName: this.detail.bidName,
                limitQuoteStartTime: this.detail.bidName
              }
            ]
          };
          // if (res && res.data && res.data.fileInfos && res.data.fileInfos.length) {
          //   this.signFiles.forEach(item => {
          //     const obj = res.data.fileInfos.find(v => v.projectFileType === item.projectFileType);
          //     if (!obj) {
          //       return;
          //     }
          //     item.filePaths = obj.filePaths.map(v => v.allPath);
          //   });
          // }
          // if (res && res.data && res.data.transactionInfos && res.data.transactionInfos.length) {
          //   this.fileInfo = res.data.transactionInfos.find(item => item.transactionType === 4) || {};
          //   this.marginInfo = res.data.transactionInfos.find(item => item.transactionType === 2) || {};
          // }
        }
      });
    },
    previousStep () {
      this.$router.back();
    }
  }
};
